var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMenuTerms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E99233;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M227.9,154.4c10.6,1.6,20.2,5.1,29,10.9c24.3,15.8,36.4,45.3,30.3,73.7c-6,28-28.8,50-57.1,54.6 c-24.9,4-46.1-3.4-63.6-21.6c-1.4-1.5-2.8-2.1-4.9-2.1c-38.4,0.1-76.7,0-115.1,0c-20.6,0-35.4-14.8-35.4-35.4 c0-64.6,0-129.2,0-193.7c0-20.4,14.9-35.3,35.3-35.3c48.7,0,97.5,0,146.2,0c20.2,0,35.2,14.9,35.2,35.1c0,36.8,0,73.6,0,110.4 C227.9,152,227.9,153.2,227.9,154.4z M210.9,154.1c0-1.1,0-1.9,0-2.8c0-36.8,0-73.6,0-110.5c0-11.3-7.2-18.5-18.6-18.5 c-48.5,0-96.9,0-145.4,0c-11.6,0-18.7,7.1-18.7,18.6c0,64.5,0,129,0,193.5c0,11.4,7.1,18.5,18.5,18.5c34.6,0,69.2,0,103.8,0 c1,0,2,0,3.2,0c-8.8-22.1-8.3-43.5,3.6-63.9C169.2,168.7,187.3,157.4,210.9,154.1z M164.8,224c-0.3,29,23.5,53.3,52.6,53.7 c29.9,0.4,54.2-23.3,54.4-53.2c0.3-29.2-23.4-53.3-52.8-53.7C189.3,170.4,165.1,194.2,164.8,224z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.8,78.1c-8.1,0-16.2,0.1-24.3,0c-5.1,0-8.7-3-9.2-7.4c-0.7-5.4,3.2-9.5,8.9-9.5c14.4,0,28.8,0,43.2,0 c2.2,0,4.3,0,6.5,0c5.2,0.1,8.8,3.5,8.8,8.3c0.1,4.8-3.4,8.4-8.5,8.6c-3.9,0.2-7.9,0.1-11.9,0.1C88.8,78.1,84.3,78.1,79.8,78.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.1,95.1c8.1,0,16.2,0,24.3,0c5.6,0,9.3,3.3,9.3,8.3c0,5-3.7,8.6-9.2,8.6c-16.4,0.1-32.8,0.1-49.1,0 c-5.5,0-9.2-3.6-9.2-8.6c0-5,3.7-8.3,9.3-8.4C63.7,95.1,71.9,95.1,80.1,95.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.1,129c8.1,0,16.2,0,24.3,0c5.6,0,9.3,3.4,9.3,8.4c0,5-3.7,8.5-9.2,8.6c-16.4,0.1-32.8,0.1-49.1,0 c-5.5,0-9.2-3.6-9.2-8.6c0-5,3.7-8.3,9.4-8.3C63.8,129,72,129,80.1,129z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80,162.9c8.1,0,16.2,0,24.3,0c5.7,0,9.4,3.3,9.4,8.2c0.1,5.1-3.7,8.7-9.4,8.7c-16.3,0-32.6,0.1-48.9,0 c-5.5,0-9.3-3.5-9.3-8.5c0-5.1,3.7-8.4,9.5-8.5C63.8,162.9,71.9,162.9,80,162.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.2,197.3c8,0,16,0,24,0c5.8,0,9.5,3.3,9.5,8.4c0,5.1-3.8,8.5-9.5,8.5c-16.3,0-32.6,0-48.9,0 c-4.8,0-8.3-2.8-9-7c-0.7-4.1,1.5-8.1,5.4-9.4c1.3-0.4,2.8-0.5,4.2-0.5C64,197.3,72.1,197.3,80.2,197.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159,61.2c8.2,0,16.4,0,24.6,0c5.6,0,9.3,3.4,9.3,8.4c0,4.9-3.7,8.5-9.2,8.5c-16.4,0.1-32.8,0.1-49.1,0 c-5.5,0-9.2-3.7-9.1-8.6c0.1-5,3.8-8.3,9.4-8.3C142.9,61.2,150.9,61.2,159,61.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.2,95.1c8.1,0,16.2,0,24.3,0c5.6,0,9.3,3.3,9.4,8.3c0.1,5-3.6,8.6-9.1,8.6c-16.4,0.1-32.8,0.1-49.1,0 c-5.5,0-9.2-3.6-9.2-8.5c0-5,3.7-8.4,9.3-8.4C142.9,95.1,151,95.1,159.2,95.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.2,129c4,0,7.9-0.1,11.9,0c4.8,0.1,8.3,3.4,8.6,8c0.3,4.4-3.1,8.6-7.8,8.8c-8.6,0.3-17.1,0.3-25.7,0 c-4.9-0.2-8.1-4.2-7.8-9c0.3-4.5,3.8-7.8,8.7-7.8C138.1,128.9,142.2,129,146.2,129z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.3,229.3c5.8-7.3,11.6-14.4,17.3-21.5c1.5-1.9,3-3.9,4.6-5.7c3.2-3.7,8.3-4.2,11.9-1.3 c3.5,2.8,4.3,8,1.4,11.6c-9,11.4-18.1,22.7-27.2,33.9c-2.9,3.5-7.4,4.1-11.2,1.4c-6.9-4.8-13.7-9.7-20.4-14.7 c-3.8-2.9-4.5-8.1-1.7-11.8c2.7-3.6,7.7-4.5,11.6-1.8C204.2,222.7,208.6,226,213.3,229.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuTerms);
export default __webpack_public_path__ + "static/media/icon-menu-terms.8b92c53163f146444f3eb98072edbd45.svg";
export { ForwardRef as ReactComponent };